// Email/Password signup - calls Rails backend directly
// Google OAuth is handled by OmniAuth (form submission to /auth/google_oauth2)

document.addEventListener('turbo:load', () => {
  const signupForm = document.getElementById('signup-form');
  const errorDiv = document.getElementById('error-message');

  // Check if the path starts with /en (our only non-default locale)
  const pathSegment = window.location.pathname.split('/')[1];
  const localePrefix = (pathSegment === 'en') ? '/en' : '';

  // Email/Password Sign Up
  if (signupForm) {
    signupForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideError();
      
      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;
      const passwordConfirm = document.getElementById('password-confirm').value;

      if (password !== passwordConfirm) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.passwords_dont_match'] || 'Passwords do not match');
        return;
      }

      try {
        const response = await fetch(`${localePrefix}/signup/password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || ''
          },
          body: JSON.stringify({ email, password, password_confirmation: passwordConfirm })
        });

        const data = await response.json();
        
        if (data.success) {
          // Shared attribution props (locale/region/user_role/campaign_source)
          // set on <body> by plausible_default_props. campaign_source carries
          // the landing-page src (e.g. lp_ad4) so both trackers can attribute
          // the registration to the campaign.
          const props = JSON.parse(document.body.dataset.plausibleProps || '{}');
          // FB Pixel — standard event fired directly here (not via flash)
          // so a future refactor of this transition can't silently break
          // it. try/catch ensures tracking failures can NEVER strand the
          // user post-signup: even if fbq() throws inside its own SDK
          // (rare but possible if Meta's script is corrupted), the
          // redirect proceeds. Tracking is best-effort; navigation is
          // load-bearing. Pass `source` so Meta can segment by campaign
          // (Meta ignores unknown custom keys, so this is always safe).
          try {
            if (typeof fbq !== 'undefined') {
              fbq('track', 'CompleteRegistration', { source: props.campaign_source });
            }
          } catch (e) { /* swallow — tracking never blocks the redirect */ }
          // Plausible — defer the redirect until the beacon fires (or
          // 500ms timeout). Without the callback the immediate
          // window.location.href = ... kills the outgoing beacon queue
          // before Plausible receives the event, which is why the
          // Signed Up goal showed 0 conversions on 2026-07-14 despite
          // 4 real signups in the DB. The 500ms setTimeout is a safety
          // net so a stalled Plausible SDK can never strand the user
          // post-signup — the redirect always fires within half a
          // second. `redirected` flag prevents double navigation if
          // callback + timeout both fire.
          let redirected = false;
          const doRedirect = () => {
            if (redirected) return;
            redirected = true;
            window.location.href = data.redirect_url;
          };
          try {
            if (typeof plausible !== 'undefined') {
              plausible('CompleteRegistration', { props, callback: doRedirect });
              setTimeout(doRedirect, 500);
            } else {
              doRedirect();
            }
          } catch (e) { doRedirect(); }
        } else {
          showLoading(false);
          showError(data.error);
        }
      } catch (error) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Connection error. Please try again.');
      }
    });
  }

  function showError(message) {
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.remove('hidden');
    }
  }

  function hideError() {
    if (errorDiv) {
      errorDiv.classList.add('hidden');
    }
  }

  function showLoading(loading) {
    const btnText = document.getElementById('signup-btn-text');
    const btnLoading = document.getElementById('signup-btn-loading');
    
    if (loading) {
      btnText?.classList.add('hidden');
      btnLoading?.classList.remove('hidden');
    } else {
      btnText?.classList.remove('hidden');
      btnLoading?.classList.add('hidden');
    }
  }
});